var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProviderContactsHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00a0df;}.cls-2{fill:#ff75b0;}.cls-3{fill:#febe10;}.cls-4{fill:#00d89a;}.cls-5{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_204",
    "data-name": "Layer 204"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 0.27,
    width: 272.83,
    height: 272.89,
    rx: 69.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 327.17,
    y: 0.27,
    width: 272.83,
    height: 272.89,
    rx: 69.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 327.39,
    width: 272.83,
    height: 272.89,
    rx: 69.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 327.17,
    y: 327.39,
    width: 272.83,
    height: 272.89,
    rx: 69.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "calendar",
    className: "cls-5",
    d: "M232.54,102.42V73.59c0-10.57-9.56-19.22-21.37-19.22H204.9V44.76a9.61,9.61,0,0,0-19.22,0v9.61H84.47V44.76a9.61,9.61,0,1,0-19.22,0v9.61H61.62c-11.8,0-21.37,8.65-21.37,19.22v28.83h0V208.13c0,10.62,9.57,19.22,21.37,19.22H211.17c11.81,0,21.37-8.6,21.37-19.22V102.42ZM55.25,73.59c0-2,2.73-4.22,6.37-4.22H211.17c3.65,0,6.37,2.23,6.37,4.22v26H55.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "user",
    className: "cls-5",
    d: "M170.41,477.93a49.26,49.26,0,0,1,25.31,6.85A51.07,51.07,0,0,1,221,528.9v16a17.65,17.65,0,0,1-5.29,12.93,17.41,17.41,0,0,1-12.84,5.33H69.94A17.41,17.41,0,0,1,57.1,557.8a17.65,17.65,0,0,1-5.29-12.93v-16a51.05,51.05,0,0,1,25.31-44.12,49.2,49.2,0,0,1,25.3-6.85h6.42a65.57,65.57,0,0,0,55.15,0Zm-34-12.17a47.71,47.71,0,0,1-24.37-6.47A47.18,47.18,0,0,1,94.49,441.6a50.07,50.07,0,0,1,0-49.06,48.69,48.69,0,0,1,66.29-17.69,47.18,47.18,0,0,1,17.56,17.69,50.07,50.07,0,0,1,0,49.06,47.11,47.11,0,0,1-17.56,17.69A47.7,47.7,0,0,1,136.42,465.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plus",
    className: "cls-5",
    d: "M532.56,436.44H488.48v-41.6a27.45,27.45,0,0,0-27.36-27.37h0a27.45,27.45,0,0,0-27.36,27.37v41.6H394.61a27.45,27.45,0,0,0-27.36,27.37h0a27.44,27.44,0,0,0,27.36,27.36h39.15v41.65a27.45,27.45,0,0,0,27.36,27.37h0a27.45,27.45,0,0,0,27.36-27.37V491.17h44.08a27.44,27.44,0,0,0,27.36-27.36h0A27.45,27.45,0,0,0,532.56,436.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow",
    className: "cls-5",
    d: "M549.35,70.9,503.66,65a12.24,12.24,0,0,0-10.78,20.22l11.63,13.25-30.49,36-28.14-20.24a17.51,17.51,0,0,0-23.7,3.05l-50.54,61a17.5,17.5,0,0,0,27,22.32l40.11-48.45,28,20.14a17.51,17.51,0,0,0,23.58-2.9L527.86,125l10.71,12.18A12.24,12.24,0,0,0,560,129.12V83A12.24,12.24,0,0,0,549.35,70.9Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProviderContactsHome);
export default __webpack_public_path__ + "static/media/provider_contacts_home.5b390dfde0cffa3435b89f9794ca1d94.svg";
export { ForwardRef as ReactComponent };